import actions from './actions';

const initState = {
  pageRoles: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0,
  },
  loading: false,
  error: '',
  lastUpdated: null,
};

export default function pageRolesReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_PAGE_ROLES:
    case actions.CREATE_PAGE_ROLE:
    case actions.UPDATE_PAGE_ROLE:
    case actions.DELETE_PAGE_ROLE:
      return {
        ...state,
        loading: true,
        error: '',
      };

    case actions.GET_PAGE_ROLES_SUCCESS:
      return {
        ...state,
        pageRoles: action.pageRoles,
        pagination: action.pagination || state.pagination,
        loading: false,
        error: '',
        lastUpdated: new Date().toISOString(),
      };

    case actions.CREATE_PAGE_ROLE_SUCCESS:
      return {
        ...state,
        pageRoles: [...state.pageRoles, action.pageRole],
        loading: false,
        error: '',
      };

    case actions.UPDATE_PAGE_ROLE_SUCCESS:
      return {
        ...state,
        pageRoles: state.pageRoles.map(role =>
          role.id === action.pageRole.id ? action.pageRole : role
        ),
        loading: false,
        error: '',
      };

    case actions.DELETE_PAGE_ROLE_SUCCESS:
      return {
        ...state,
        pageRoles: state.pageRoles.filter(role => role.id !== action.roleId),
        loading: false,
        error: '',
      };

    case actions.GET_PAGE_ROLES_ERROR:
    case actions.CREATE_PAGE_ROLE_ERROR:
    case actions.UPDATE_PAGE_ROLE_ERROR:
    case actions.DELETE_PAGE_ROLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case actions.CLEAR_PAGE_ROLES_ERROR:
      return {
        ...state,
        error: '',
      };

    default:
      return state;
  }
}
